import Dexie from 'dexie';

export const DB_THRESHOLD = 200 * 1024 * 1024;

export const db = new Dexie('dslDatabase');

db.version(1).stores({
  files: '++fileName, blob, mimeType'
});

export const getFilesTableSize = async () => {
  const records = await db.files.toArray();
  let totalSize = 0;
  records.forEach(record => {
    totalSize += record?.blob?.size || 0;
  });
  return totalSize;
};
